import React from 'react';
import { Activity, Truck, HeartPulse, Map, ArrowRight, BoxIcon } from 'lucide-react';
import { motion } from 'framer-motion';
import { PageTransition } from '../components/PageTransition';
export function Services() {
  const services = [{
    icon: Activity,
    title: 'Stretcher Transport',
    desc: 'Professional stretcher transport for patients requiring recumbent positioning. Our vehicles are equipped with state-of-the-art Stryker stretchers and monitored by certified personnel.',
    features: ['Bed-to-bed service', 'Oxygen available upon request', 'Bariatric stretchers available']
  }, {
    icon: BoxIcon,
    title: 'Wheelchair Transport',
    desc: 'Safe and comfortable transport for individuals using standard or motorized wheelchairs. Our modern fleet features ADA-compliant hydraulic lifts and securement systems.',
    features: ['Door-to-door assistance', 'Accommodates oversized chairs', 'Family members can ride along']
  }, {
    icon: HeartPulse,
    title: 'Ambulatory Transport',
    desc: 'Reliable assistance for patients who can walk but need help getting to and from their appointments safely. Perfect for physical therapy, dialysis, or routine check-ups.',
    features: ['Arm-in-arm assistance', 'Help with doors and stairs', 'Wait-and-return options']
  }, {
    icon: Map,
    title: 'Long Distance Transport',
    desc: 'Comfortable, medically-supported transportation across state lines or long distances for facility transfers or moving closer to family.',
    features: ['Comfortable, spacious vehicles', 'Two-driver teams for safety', 'Customized travel itineraries']
  }];
  return <PageTransition data-id="element-282">
      <div className="bg-white" data-id="element-283">
        {/* Page Header */}
        <div className="bg-brand-light py-20 lg:py-32" data-id="element-284">
          <div className="container mx-auto px-4 md:px-6 text-center" data-id="element-285">
            <motion.h1 initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-brand-blue mb-6 tracking-tight" data-id="element-286">
              Our Services
            </motion.h1>
            <motion.p initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.1
          }} className="text-lg md:text-xl text-gray-700 max-w-3xl mx-auto leading-relaxed" data-id="element-287">
              Comprehensive non-emergency medical transportation solutions
              tailored to your specific needs.
            </motion.p>
          </div>
        </div>

        <section className="py-20" data-id="element-288">
          <div className="container mx-auto px-4 md:px-6" data-id="element-289">
            <div className="grid gap-12" data-id="element-290">
              {services.map((service, i) => <motion.div key={i} initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true,
              margin: '-50px'
            }} transition={{
              duration: 0.5
            }} className="flex flex-col md:flex-row gap-8 items-start bg-white p-8 md:p-10 rounded-3xl border border-gray-100 shadow-sm hover:shadow-xl transition-shadow" data-id="element-291">
                  <div className="w-20 h-20 shrink-0 bg-brand-light rounded-2xl flex items-center justify-center text-brand-blue" data-id="element-292">
                    <service.icon size={40} data-id="element-293" />
                  </div>
                  <div className="flex-grow" data-id="element-294">
                    <h2 className="text-2xl md:text-3xl font-bold text-brand-blue mb-4" data-id="element-295">
                      {service.title}
                    </h2>
                    <p className="text-lg text-gray-600 leading-relaxed mb-6" data-id="element-296">
                      {service.desc}
                    </p>
                    <ul className="grid sm:grid-cols-2 gap-3" data-id="element-297">
                      {service.features.map((feature, idx) => <li key={idx} className="flex items-center gap-2 text-gray-700 font-medium" data-id="element-298">
                          <div className="w-2 h-2 rounded-full bg-brand-blue" data-id="element-299" />
                          {feature}
                        </li>)}
                    </ul>
                  </div>
                  <div className="shrink-0 mt-6 md:mt-0" data-id="element-300">
                    <button className="flex items-center gap-2 bg-brand-blue text-white px-6 py-3 rounded-full font-bold hover:bg-blue-800 transition-colors" data-id="element-301">
                      Book Now <ArrowRight size={18} data-id="element-302" />
                    </button>
                  </div>
                </motion.div>)}
            </div>
          </div>
        </section>
      </div>
    </PageTransition>;
}